import L from 'leaflet'
import { ref } from '@vue/composition-api'

export default function mapDrawGeofences(map) {

  const geofenceVisibility = ref(true)
  const allGeofencesDraw = ref([])

  const shapeLayers = new L.FeatureGroup()
  const removeAllGeos = () => shapeLayers.clearLayers()

  const drawArea = (g, device_areas) => {
    map.value.createPane("PanPolyline").style.zIndex = 222;
    map.value.createPane("PanCircle").style.zIndex = 512;
    const area = g.area
    const att = g.attributes
    const type = area.slice(0,1)
    const color = (device_areas !== undefined && (g.id in device_areas)) ? 'red' : att['color']
    const options = { weight: 3, fillColor: color, fillOpacity: 0.3, opacity: 1, color: 'black',pane:'PanPolyline'}

    switch(type) {
      case 'C':
        const { latLng, r } = ExtractCircleData(area)
        const c = L.circle([parseFloat(latLng[0]), parseFloat(latLng[1])], {...options,  radius: r})
          .bindTooltip(`<div style="background: white;font-size:1rem;padding:5px; border:1px solid; !important;">${g.name}</div>`, {
          permanent: false, direction:"center", className: 'bindTooltipStyle'}).openTooltip()
        shapeLayers.addLayer(c)
        allGeofencesDraw.value[g.id] = c
        break
      case 'P':
        const points = extractPolygonData(area)
        const P = L.polygon(points.map((v, i) => [
          parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]),options)
          .bindTooltip(`<div class="g_name" style="background: white;font-size:1rem;padding:5px; border:1px solid; !important; ">${g.name}</div>`, {
            permanent: false, direction:"center", className: 'bindTooltipStyle'}).openTooltip()
        shapeLayers.addLayer(P)
        allGeofencesDraw.value[g.id] = P
        break
      case 'L':
        const linePoints = extractLineData(area)
        const Line = L.polyline(linePoints.map((v, i) => [
          parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]), options)
          .bindTooltip(`<div style="background: white;font-size:1rem;padding:5px; border:1px solid; !important;">${g.name}</div>`, {
          permanent: false, direction:"center", className: 'bindTooltipStyle'}).openTooltip()
        shapeLayers.addLayer(Line)
        allGeofencesDraw.value[g.id] = Line
        break
    }

    shapeLayers.addTo(map.value)
  }


  const extractPolygonData = (area) => {
    return area.split('((')[1].slice(0, -2).split(', ')
  }

  const extractLineData = (area) => {
    return area.split('(')[1].slice(0, -1).split(', ')
  }


  const ExtractCircleData = (area) => {
    const points = ((area.split('(')[1]).slice(0, -1)).split(', ')
    const latLng = points[0].split(' ')
    const r = points[1]

    return {
      latLng, r
    }
  }



  return {
    drawArea,
    removeAllGeos,
    geofenceVisibility, allGeofencesDraw
  }
}
